export var container = {
    width: '100%',
    height: '100%',
    position: 'relative'
};
export var map = {
    width: '100%',
    height: '100%'
};
